import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
// import { useDispatch } from 'react-redux';
import { Logout } from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

function LogoutButton(props) {
    const { onLogout } = props
    const { logout } = useAuth0();
    // const dispatch = useDispatch();

    const getReturnPath = () => {
        let path = `${window.location.protocol}//${window.location.host}`;
        console.log(path);
        return path;
    }

    return (
        <MenuItem
            onClick={async () => {
                // dispatch(processingShow({message: "Logging out..."}));
                
                setTimeout(() => {
                    logout({
                        logoutParams:{
                            returnTo: getReturnPath()
                        }
                    });
                    if(onLogout) {
                        onLogout();
                    }
                }, 1500); // artificial delay to allow the popup to be displayed and the monitor to be canceled.
            }}
        >
            <Logout sx={{paddingRight: "5px", verticalAlign: "bottom"}} />Log Out
        </MenuItem>
    );
}

LogoutButton.propTypes = {
    onLogout: PropTypes.func.isRequired,
}

export default LogoutButton;